import { ChannelPayloadFilter, SpyneTrait } from "spyne";

export class ScriptContentTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "scriptContent$";

    super(context, traitPrefix);
  }

  static scriptContent$HelloWorld() {
    return "Hello World";
  }

  static scriptContent$OnCodeRevealEvent(e) {
    const { scriptNum } = e.payload;
    const isActiveBool = scriptNum === this.props.scriptNum;

    this.props.el$.toggleClass("active", isActiveBool);
  }

  static scriptContent$CreateActionListeners(props = this.props) {
    const { parentVsid } = props;
    //console.log('parent vsid ',{parentVsid});

    const codeFilter = new ChannelPayloadFilter({
      payload: (p) => p.parentVsid === parentVsid,
    });

    return ["CHANNEL_CODE_CONTAINER_CODE_REVEAL_EVENT", "onCodeRevealEvent"];
  }
}
